import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps";
import { useTranslation } from "react-i18next";

const VatTypeAutoComplete: React.FC<AutoCompleteProps> = ({ onChange, valueId, label, load = true, infoText, disabled = false, error, helperText}) => {
    const { t } = useTranslation();
    return (
        <AsyncAutoCompleteContained
            label={label ?? t("common.vatType")}
            url="/autocompleteApi/VatType"
            valueId={valueId}
            load={load}
            onChange={onChange}
            infoText={infoText}
            error={error}
            helperText={helperText}
            disabled={ disabled}
        />
    );
};

export default VatTypeAutoComplete;
